import { Directive, DoCheck, ElementRef, Input, inject } from '@angular/core';

/**
 * Syncs the native `indeterminate` property; Angular’s `[checked]` binding does not set it.
 */
@Directive({
  selector: 'input[type=checkbox][locIndeterminate]',
  standalone: true,
})
export class LocIndeterminateDirective implements DoCheck {
  private el = inject(ElementRef<HTMLInputElement>);

  @Input() locIndeterminate = false;

  ngDoCheck(): void {
    this.el.nativeElement.indeterminate = this.locIndeterminate;
  }
}
